import { apiClient } from './api';
import { db } from './firebase';
import { collection, query, getDocs, orderBy } from 'firebase/firestore';

export interface RestaurantCategory {
  categoryId: string;
  name: string;
  slug: string;
  icon?: string;
  image?: string;
  order: number;
  isActive: boolean;
  createdAt: { seconds: number; nanoseconds: number };
  updatedAt: { seconds: number; nanoseconds: number };
}

/**
 * Listar categorías (Directo a Firestore)
 */
export async function listRestaurantCategories(): Promise<RestaurantCategory[]> {
  try {
    const q = query(collection(db, 'restaurant_categories'), orderBy('order', 'asc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ categoryId: doc.id, ...doc.data() } as RestaurantCategory));
  } catch (error) {
    console.error("Error listing categories:", error);
    return [];
  }
}

// Las rutas/métodos deben coincidir con las Cloud Functions standalone (backend: modules/admin/restaurant-categories.*)
export async function createRestaurantCategory(data: any) {
  const response = await apiClient.post('/createRestaurantCategory', data);
  return response.data;
}

export async function updateRestaurantCategory(categoryId: string, data: any) {
  const response = await apiClient.put('/updateRestaurantCategory', data, { params: { categoryId } });
  return response.data;
}

export async function deleteRestaurantCategory(categoryId: string) {
  const response = await apiClient.delete('/deleteRestaurantCategory', { params: { categoryId } });
  return response.data;
}

export async function toggleRestaurantCategory(categoryId: string) {
  const response = await apiClient.put('/toggleRestaurantCategory', undefined, { params: { categoryId } });
  return response.data;
}

export async function reorderRestaurantCategories(data: { categoryIds: string[] }) {
  const response = await apiClient.put('/reorderRestaurantCategories', data);
  return response.data;
}

export const restaurantCategoriesService = {
  listCategories: listRestaurantCategories,
  create: createRestaurantCategory,
  update: updateRestaurantCategory,
  delete: deleteRestaurantCategory,
  toggle: toggleRestaurantCategory,
  reorder: reorderRestaurantCategories
};
